<template>
  <div
    class="import-text-dropdown-text"
    v-click-outside="closeDropdown"
    :style="dropdownStyle"
  >
    <div v-if="transcriptionType === 'videoTranscript'" class="header">
      <!-- <wt-button
        type="primary"
        class="insert-text-button"
        @click="translateText"
        :text="'Translate'"
      /> -->
      <div class="-language-list" :class="{ '-disabled': transcribing }">
        <select
          class="underline normal"
          @change="translateText"
          :disabled="transcribing || translating"
          v-model="languageCode"
        >
          <option v-for="item in languageList" :key="item.id" :value="item.id">
            {{ item.label }}
          </option>
        </select>
      </div>
      <wt-google-like-loader
        class="-default"
        v-if="transcribing || translating"
      ></wt-google-like-loader>
    </div>
    <div class="options" ref="scrollContainer">
      <div
        v-for="(text, index) in texts"
        :key="index"
        class="dropdown-item js-import-text-dropdown-text"
        ref="wordContainer"
        dir="auto"
      >
        <template v-if="typeof text === 'string'">
          {{ text }}
        </template>
        <template v-else-if="typeof text === 'object'">
          <span
            v-for="(item, index) in text"
            :class="{ highlighted: item.highlighted }"
            :key="index"
            v-text="item.content"
          />
        </template>
      </div>
    </div>
    <div class="insert-text-button-container">
      <wt-button
        :disabled="!selectedText"
        type="primary"
        class="insert-text-button"
        @click="insertText"
        :text="!selectedText ? 'Select text' : 'Insert Text'"
      />
    </div>
  </div>
</template>

<script>
import { workPool } from '@wochitnpm/helpers';

export default {
  name: 'ImportTextDropdownText',
  props: {
    selectedOption: {
      type: Object,
      required: true,
    },
    position: {
      type: Object,
      default: () => ({ x: 0, y: 0 }),
    },
  },
  data() {
    return {
      mounted: false,
      selectedText: '',
      scrolledToHighlighted: false,
      workPoolHandlers: new Set(),
      transcriptionTranslation: null,
      translating: false,
      languageList: [],
      transcribing: false,
      languageCode: '',
    };
  },
  created() {
    this.languageList = app.transcriptionLanguageList();
  },
  computed: {
    transcriptionType() {
      return this.selectedOption.transcriptionType;
    },
    transcriptions() {
      return this.$store.state.story.transcriptions;
    },
    videoTranscriptionJob() {
      let transcriptionJob;
      if (this.selectedOption.transcriptions?.length === 1) {
        const transcription = this.selectedOption.transcriptions[0];
        if (transcription.type === 'videoTranscript') {
          const transcriptionId = this.selectedOption.transcriptions[0].id;
          transcriptionJob = this.transcriptions[transcriptionId];
        }
      }
      return transcriptionJob;
    },
    texts() {
      if (this.selectedOption.transcriptions) {
        const texts = [];
        this.selectedOption.transcriptions.forEach((transcription) => {
          const transcriptTexts = [];
          let startTime = null;
          let endTime = null;

          if (transcription.relevantTimes?.length) {
            startTime = transcription.relevantTimes[0];
            endTime = transcription.relevantTimes[1];
          }
          const transcriptionId = transcription.id;
          let transcriptionJob = this.transcriptions[transcriptionId];
          if (this.transcriptionTranslation) {
            transcriptionJob = this.transcriptionTranslation;
          }
          if (
            !transcriptionJob ||
            (transcriptionJob.status !== 'DONE' &&
              transcriptionJob.status !== 'UPDATED')
          ) {
            let statusText = '';
            switch (transcriptionJob.status) {
              case 'PENDING':
                statusText = 'Transcript in process...';
                break;
              case 'FAILED':
                statusText = 'Transcript failed';
                break;
            }
            texts.push(statusText);
            return;
          }
          const transcriptionTokens = transcriptionJob?.tokens || [];
          // const paragraphs = [];
          let currentParagraph;
          let pCount = 0;
          transcriptionTokens.forEach((token) => {
            if (token.type !== 'WORD') {
              return;
            }
            let highlighted = false;
            // const ret = {
            //   content: token.content,
            // };
            if (
              typeof startTime === 'number' &&
              typeof endTime === 'number' &&
              token.startTime >= startTime &&
              token.endTime <= endTime
            ) {
              highlighted = true;
            }

            if (
              !currentParagraph ||
              currentParagraph.highlighted !== highlighted
            ) {
              if (currentParagraph) {
                transcriptTexts.push(currentParagraph);
              }
              currentParagraph = {
                highlighted,
                content: pCount ? ' ' + token.content : token.content,
              };
              pCount++;
            } else {
              currentParagraph.content += ' ' + token.content;
            }
          });

          if (currentParagraph) {
            transcriptTexts.push(currentParagraph);
          }

          if (transcriptTexts.length) {
            texts.push(transcriptTexts);
          }
          // const transcriptionText = transcriptionTokens.map(
          //   (token) => token.content
          // );
        });
        return texts;
      }
      if (this.selectedOption.texts) {
        return this.selectedOption.texts;
      }

      return [];
    },
    dropdownStyle() {
      return {
        zIndex: 10000, // Higher than parent dropdown
        left: `${this.position.x}px`,
        top: `${this.position.y}px`,
        marginLeft: '2px',
        marginTop: '2px',
      };
    },
  },
  watch: {
    videoTranscriptionJob: {
      handler(newVal) {
        const languageCode = newVal?.languageCode?.split('-')[0] || '';
        this.languageCode = languageCode;
      },
      deep: true,
      immediate: true,
    },
    texts: {
      async handler(newVal) {
        await this.$nextTick();
        if (this.scrolledToHighlighted) {
          return;
        }
        if (this.selectedOption.transcriptions) {
          if (!this.$refs.wordContainer) {
            return;
          }
          for (const wordContainer of this.$refs.wordContainer) {
            const highlightedChild =
              wordContainer.querySelector('.highlighted');
            if (highlightedChild) {
              let offsetY = highlightedChild.offsetTop;
              if (offsetY > 25) {
                offsetY -= 25;
              }
              const container = this.$refs.scrollContainer;
              container.scrollTop = Math.max(offsetY - container.offsetTop, 0);
              this.scrolledToHighlighted = true;
              break;
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.mounted = true;
    this.setupTextSelectionListener();
  },
  beforeDestroy() {
    this.cleanupTextSelectionListener();
    workPool.off(this.workPoolHandlers);
  },
  methods: {
    translateText() {
      const assetUUID =
        this.$store.state.assetEditor?.workModel?.metadata?.assetUUID;
      workPool.job.transcriptions.execute({
        asset: this.$store.state.assetEditor?.workModel,
        transcribeSubType: app.transcribeSubType.VIDEO,
        how: workPool.job.transcriptions.HOW.READ_OR_CREATE,
        languageCode: this.languageCode,
        programmerAllowedTranscription: true,
        alertOnError: false,
      });
      workPool.on(
        {
          type: workPool.job.transcriptions.type,
          context: (jc) => jc.assetUUID === assetUUID,
        },
        (payload) => {
          if (payload.failedToCreate) {
            console.log('failed to create transcription');
          } else if (payload.processing) {
            console.log('processing');
          } else {
            this.scrolledToHighlighted = false;
            this.transcriptionTranslation = {
              status: payload.transcriptionStatus,
              tokens: payload.tokens,
            };
            this.translating = false;
          }
        },
        this.workPoolHandlers
      );
    },
    closeDropdown(e) {
      if (
        !this.mounted ||
        e.target?.classList?.contains('js-import-text-dropdown-text')
      ) {
        return;
      }
      this.$emit('close');
    },
    insertText() {
      this.$emit('insert', this.selectedText);
    },
    setupTextSelectionListener() {
      document.addEventListener('selectionchange', this.handleTextSelection);
      document.addEventListener('mouseup', this.handleTextSelection);
      document.addEventListener('keyup', this.handleTextSelection);
    },
    cleanupTextSelectionListener() {
      document.removeEventListener('selectionchange', this.handleTextSelection);
      document.removeEventListener('mouseup', this.handleTextSelection);
      document.removeEventListener('keyup', this.handleTextSelection);
    },
    handleTextSelection() {
      const selection = window.getSelection();
      if (selection && selection.toString().trim()) {
        this.selectedText = selection.toString().trim();
      } else {
        if (this.selectedText) {
          this.selectedText = '';
        }
      }
    },
    getDisplayText(text) {
      // Implement your logic to get the display text here
      return text;
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.import-text-dropdown-text {
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-50%);
  z-index: 10000;
  width: 400px;

  position: absolute;
  display: inline-block;
  z-index: 10000;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 5px;
  border-radius: 4px;
}

.options {
  overflow-y: auto;
  max-height: 300px;
  padding: 8px;
  max-width: 100%;
  word-break: break-word;
}

.dropdown-item {
  // display: flex;
  // align-items: center;
  padding: 0 0 10px 0;
  text-align: initial;
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  span {
    display: inline;
  }
  span.highlighted {
    background-color: rgba(6, 169, 244, 0.2);
  }
}

.text-preview {
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;

  // // Truncate long text with ellipsis
  // display: -webkit-box;
  // -webkit-line-clamp: 2;
  // -webkit-box-orient: vertical;
  // overflow: hidden;
  // text-overflow: ellipsis;
}

.insert-text-button-container {
  padding: 0 8px 8px 8px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.insert-text-button {
  min-width: unset !important;
  padding: 6px 12px !important;
  font-size: 14px !important;
  height: 32px !important;
}
.-language-list {
  display: inline-block;
  position: relative;
  width: 150px;
  font-size: 14px;
  margin: 6px 0 0 6px;

  &.-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 100%;
    padding: 3px 20px 3px 2px;
    font-weight: 300;
    text-align: left;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    font-size: 13px;
    color: inherit;
    text-overflow: ellipsis;

    &:hover,
    &:focus {
      // color: $wt-blue-light !important;
      background: white;
      border-bottom-color: $wt-blue-light !important;
      outline: 0 !important;
      box-shadow: none;
    }

    option {
      padding: 8px 10px;
      font-size: 14px;
      font-weight: 400;
      background-color: $white;
      color: $dark-text-color;

      &:checked {
        color: $wt-blue-light;
        background-color: $white;
      }

      &:hover {
        background-color: $white;
        text-shadow: 0.1px 0.1px #ccc;
      }
    }
  }

  &::after {
    content: '';
    position: absolute;
    right: 7px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #666;
    pointer-events: none;
    transition: transform 0.3s;
  }

  select:focus + &::after {
    transform: translateY(-50%) rotate(180deg);
  }
}
</style>
